(function () {
  'use strict';

  var context = window.BerryBowCommerceContext || {};
  var currency = context.currency || null;
  var currentCart = context.cart || { total_price_minor: 0, items: [] };
  var emitted = Object.create(null);
  var touchKeys = ['content_id', 'candidate_id', 'campaign_id', 'adset_id', 'ad_id', 'utm_source', 'utm_medium', 'fbclid'];
  var eventDenied = false;

  function clean(value, maxLength) {
    if (!value) return null;
    return String(value).trim().slice(0, maxLength || 120).replace(/[^a-zA-Z0-9._:/-]/g, '-');
  }

  function storageGet(storage, key) {
    try { return storage.getItem(key) || ''; } catch (_) { return ''; }
  }

  function storageSet(storage, key, value) {
    try { storage.setItem(key, value); } catch (_) {}
  }

  function marketingAllowed() {
    if (eventDenied) return false;
    try {
      var privacy = window.Shopify && window.Shopify.customerPrivacy;
      return !!privacy && typeof privacy.marketingAllowed === 'function' && privacy.marketingAllowed() === true;
    } catch (_) {
      return false;
    }
  }

  function clearMarketingTouches() {
    touchKeys.forEach(function (key) {
      try { window.localStorage.removeItem('berrybow_touch_' + key); } catch (_) {}
    });
  }

  function eventId() {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') return window.crypto.randomUUID();
    return 'bb-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 14);
  }

  function touchFromLocation() {
    var params = new URLSearchParams(window.location.search);
    var fields = {
      content_id: clean(params.get('bb_content') || params.get('utm_content'), 100),
      candidate_id: clean(params.get('bb_candidate') || params.get('candidate_id'), 120),
      campaign_id: clean(params.get('bb_campaign') || params.get('utm_campaign'), 120),
      adset_id: clean(params.get('bb_adset'), 80),
      ad_id: clean(params.get('bb_ad'), 80),
      utm_source: clean(params.get('utm_source'), 60),
      utm_medium: clean(params.get('utm_medium'), 60),
      fbclid: clean(params.get('fbclid'), 180)
    };
    Object.keys(fields).forEach(function (key) {
      if (fields[key]) storageSet(window.localStorage, 'berrybow_touch_' + key, fields[key]);
    });
    return fields;
  }

  function attribution() {
    if (!marketingAllowed()) return {};
    var current = touchFromLocation();
    var result = {};
    Object.keys(current).forEach(function (key) {
      result[key] = current[key] || clean(storageGet(window.localStorage, 'berrybow_touch_' + key), key === 'fbclid' ? 180 : 120);
    });
    return result;
  }

  function syncMarketingTouches(event) {
    if (event && event.type === 'trackingConsentAccepted') eventDenied = false;
    if (event && event.detail && typeof event.detail.marketingAllowed === 'boolean') eventDenied = !event.detail.marketingAllowed;
    if (!marketingAllowed()) {
      clearMarketingTouches();
      return;
    }
    touchFromLocation();
  }

  function watchMarketingConsent() {
    document.addEventListener('visitorConsentCollected', syncMarketingTouches);
    document.addEventListener('trackingConsentAccepted', syncMarketingTouches);
    syncMarketingTouches();
    var shopify = window.Shopify;
    if (!shopify || typeof shopify.loadFeatures !== 'function' || (shopify.customerPrivacy && typeof shopify.customerPrivacy.marketingAllowed === 'function')) return;
    try {
      shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
        if (!error) syncMarketingTouches();
      });
    } catch (_) {}
  }

  function item(raw, quantity) {
    if (!raw) return null;
    var priceMinor = Number(raw.price_minor ?? raw.final_price ?? raw.price ?? 0);
    return {
      item_id: String(raw.item_id ?? raw.product_id ?? ''),
      item_name: String(raw.item_name ?? raw.product_title ?? raw.title ?? ''),
      item_category: String(raw.item_category ?? raw.product_type ?? ''),
      item_variant: String(raw.item_variant ?? raw.variant_title ?? ''),
      variant_id: String(raw.variant_id ?? raw.id ?? ''),
      sku: String(raw.sku || ''),
      price: Number.isFinite(priceMinor) ? priceMinor / 100 : null,
      quantity: Number(quantity ?? raw.quantity ?? 1) || 1
    };
  }

  function emit(name, ecommerce, onceKey) {
    if (onceKey && emitted[onceKey]) return null;
    if (onceKey) emitted[onceKey] = true;
    var id = eventId();
    var detail = {
      event: name,
      event_id: id,
      event_time: new Date().toISOString(),
      ecommerce: ecommerce || {},
      berrybow_attribution: attribution(),
      source: 'berrybow-storefront-v1'
    };
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(detail);
    window.dispatchEvent(new CustomEvent('berrybow:commerce-event', { detail: detail }));
    return detail;
  }

  function cartItems(cart) {
    return (cart && Array.isArray(cart.items) ? cart.items : []).map(function (row) { return item(row); }).filter(Boolean);
  }

  function viewEvent() {
    if (context.page_type === 'product' && context.product) {
      var product = item(context.product);
      emit('view_item', { currency: currency, value: product.price, items: [product] }, 'view_item:' + product.variant_id);
    }
    if (context.page_type === 'cart') {
      emit('view_cart', {
        currency: currency,
        value: Number(currentCart.total_price_minor || currentCart.total_price || 0) / 100,
        items: cartItems(currentCart)
      }, 'view_cart');
    }
  }

  function subscribeToCart() {
    if (!window.MinimogEvents || !window.MinimogTheme || !window.MinimogTheme.pubSubEvents) return false;
    window.MinimogEvents.subscribe(window.MinimogTheme.pubSubEvents.cartUpdate, function (payload) {
      if (!payload || !payload.cart) return;
      currentCart = payload.cart;
      if (!payload.productVariantId) return;
      var variantId = String(payload.productVariantId);
      var raw = (payload.cart.items || []).find(function (row) { return String(row.variant_id || row.id) === variantId; });
      var added = item(raw, 1);
      if (!added) return;
      emit('add_to_cart', { currency: payload.cart.currency || currency, value: added.price, items: [added] });
    });
    return true;
  }

  function bindCheckout() {
    var lastCheckoutAt = 0;
    function emitCheckout() {
      var now = Date.now();
      if (now - lastCheckoutAt < 750) return;
      lastCheckoutAt = now;
      emit('begin_checkout', {
        currency: currency,
        value: Number(currentCart.total_price_minor || currentCart.total_price || 0) / 100,
        items: cartItems(currentCart)
      });
    }
    document.addEventListener('click', function (event) {
      var target = event.target && event.target.closest ? event.target.closest('a[href*="/checkout"], button[name="checkout"], input[name="checkout"]') : null;
      if (target) emitCheckout();
    }, true);
    document.addEventListener('submit', function (event) {
      var action = String(event.target && event.target.action || '');
      var submitter = event.submitter;
      if (action.indexOf('/checkout') !== -1 || submitter && submitter.name === 'checkout') emitCheckout();
    }, true);
  }

  watchMarketingConsent();
  viewEvent();
  bindCheckout();
  if (!subscribeToCart()) {
    var attempts = 0;
    var timer = window.setInterval(function () {
      attempts += 1;
      if (subscribeToCart() || attempts >= 20) window.clearInterval(timer);
    }, 250);
  }
})();
